export default class PreciseTimeout {
  constructor(callback, delay) {
    this.callback = callback;
    this.delay = delay;
    this.startTime = 0;
    this.animationFrameId = null;
    this.running = false;
  }

  start() {
    if (this.running) return;

    this.running = true;
    this.startTime = performance.now();

    const checkTimeout = (timestamp) => {
      const elapsed = performance.now() - this.startTime;

      if (elapsed >= this.delay) {
        this.running = false;
        this.callback(elapsed);
      } else {
        this.animationFrameId = requestAnimationFrame(checkTimeout);
      }
    };

    this.animationFrameId = requestAnimationFrame(checkTimeout);
  }

  cancel() {
    if (!this.running) return;
    this.running = false;
    cancelAnimationFrame(this.animationFrameId);
  }
}
